// En qué corporativo y en qué empresa se está trabajando.
//
// El terminal no lo decía en ninguna parte una vez dentro: sólo en la pantalla
// de acceso. Y el dato importa, porque un mismo corporativo aloja varias
// empresas y el mismo terminal se apunta a uno u otro cambiando un archivo.
//
// Medido en carne propia el 08/09/2026: se apuntó el terminal a Panamá y el
// corporativo seguía siendo el de Costa Rica --el nombre de la empresa se había
// cambiado, el del entorno no--. Nada en pantalla lo desmentía.

/** Las palabras con las que se nombra un entorno que no es el de producción. */
const PALABRAS_DE_PRUEBAS = new Set(["test", "dev", "qa", "sandbox", "pruebas"]);

/**
 * Si el entorno **no** es el de producción.
 *
 * Se mira segmento a segmento y no con un `includes` sobre el nombre entero: un
 * corporativo llamado «Corp_Santillana_5_Test_28» tiene su marca en medio, y
 * uno de producción podría llevar «Development» dentro del nombre de la empresa
 * sin serlo.
 *
 * **Ante la duda, producción.** De los dos errores posibles, éste es el bueno:
 * anunciar «PRUEBAS» en un terminal de producción invita a registrar de prueba
 * sobre datos reales, mientras que callarlo en uno de pruebas sólo hace que
 * alguien trabaje con más cuidado del necesario.
 *
 * @param {string} nombreDelEntorno El corporativo, tal como lo publica BC.
 */
export const esEntornoDePruebas = (nombreDelEntorno) =>
  String(nombreDelEntorno ?? "")
    .split(/[_\-.\s]+/)
    .some((parte) => PALABRAS_DE_PRUEBAS.has(parte.toLowerCase()));

/**
 * El nombre de la empresa recortado para que quepa en la cabecera.
 *
 * Se corta por palabras y no a mitad de una: «Sist_ Educativos de Enseñanza»
 * recortado a la fuerza da «Sist_ Educativos de En…», que se lee peor que
 * «Sist_ Educativos…». El nombre entero sigue estando al posar el puntero.
 */
export const nombreCortoDeLaEmpresa = (empresa, maximo = 22) => {
  const limpio = String(empresa ?? "").trim();
  if (!limpio || limpio.length <= maximo) return limpio;

  const palabras = limpio.split(/\s+/);
  let corto = "";
  for (const palabra of palabras) {
    const siguiente = corto ? `${corto} ${palabra}` : palabra;
    if (siguiente.length > maximo) break;
    corto = siguiente;
  }

  // Una sola palabra más larga que el máximo no tiene por dónde cortarse por
  // espacios: ahí sí se corta a la fuerza, que es mejor que no enseñar nada.
  return `${corto || limpio.slice(0, maximo)}…`;
};
